import {post, get} from '@/lib/axios';

const prize_shop = {
  async get_prizes() {
    return get(`/catalog`);
  },
  async catalog_detail(id) {
    return get(`/catalog/${id}`);
  },
  async get_basket(id) {
    return post(`/basket`, {id: id});
  },
  async add_basket(productId, id) {
    return post(`/basket/add`, {productId : productId, id: id});
  },
  async delete_item(productId, id) {
    return post(`/basket/delete`, {productId : productId, id: id});
  },
  async set_order(value) {
    return post(`/basket/payment`, value);
  },
  async get_order() {
    return get(`/orders`);
  },
  async get_order_detail(id) {
    return get(`/orders/${id}`);
  },
  async cancel(id) {
    return post(`/orders/${id}/cancel`);
  },
};

export {prize_shop as default};
